import darkTokens from '@/assets/themes/dark/tokens';
import defaultPalette from '@/assets/themes/default/palette';
import lightTokens from '@/assets/themes/light/tokens';
import 'eduzz-redactor/redactorx-1-4-2/redactorx.css';
import { GlobalStyles as EmotionGlobalStyles, css } from '@/styled';

const GlobalStyles = () => {
  return (
    <EmotionGlobalStyles
      styles={css`
        html {
          -webkit-font-smoothing: antialiased;
        }

        /* typography */
        h1.ant-typography {
          font-size: 2.5rem;
        }

        h2.ant-typography {
          font-size: 2rem;
        }

        h3.ant-typography {
          font-size: 1.5rem;
        }

        h4.ant-typography {
          font-size: 1.25rem;
        }

        h5.ant-typography {
          font-size: 1rem;
        }

        div.ant-typography {
          font-size: 1rem;
        }

        span.ant-typography {
          font-size: 0.875rem;
        }

        a.ant-typography {
          font-size: 0.875rem;
        }

        /* select */

        .ant-select-selection-placeholder span {
          font-size: 1rem;
        }

        /* button */
        button,
        button.ant-btn-primary,
        button.ant-btn-default {
          box-shadow: none;
        }

        /* scrollbar */
        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        ::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 8px;
        }

        html.theme-dark body::-webkit-scrollbar-track {
          background: ${defaultPalette.gray[10]};
        }

        html.theme-dark body::-webkit-scrollbar-thumb:hover {
          background: ${darkTokens.colorPrimary};
        }

        html.theme-light body::-webkit-scrollbar-track {
          background: ${defaultPalette.gray[2]};
        }

        html.theme-light body::-webkit-scrollbar-thumb:hover {
          background: ${lightTokens.colorPrimary};
        }

        /* reset antd */
        .ant-input-affix-wrapper > input.ant-input {
          background: transparent;
        }
      `}
    />
  );
};

export default GlobalStyles;
